import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null,
}

export const commonSlice = createSlice({
    name: 'main',
    initialState,
    reducers: {
        addUser: (state, action)=>{
            state.user = action.payload
        }
    }
});

export const { addUser } = commonSlice.actions;
export default commonSlice.reducer;